import { Agency } from "@adgate/common/types/agency.type";
import { CommercialOffice } from "@adgate/common/types/commercial-office.type";
import { Status } from "@adgate/common/types/status.type";

export class Campaign
{
    public static OBJECT_TYPE:number                      = 2;

    id: number;
    title!: string;
    brand!: string;
    agency!: Agency;
    commercialOffice!: CommercialOffice;
    targetUrl!: string;
    status!: Status;
    dateCreated!: number;
    lastModified!: number;

    constructor()
    {
        this.id = -1;
    }    
}